import { render, staticRenderFns } from "./in-out-stock-table.vue?vue&type=template&id=01831c5e&"
import script from "./in-out-stock-table.vue?vue&type=script&lang=js&"
export * from "./in-out-stock-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports